import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";
import { PageableResponse } from "../PageableResponse";

export type B000190FindRequest = Partial<{
  sokoCdFrom: string;
  sokoCdTo: string;
  sokoshubetsuList: string[];
  // 削除予定区分チェック除外区分
  deljogaiKbn: string;
  name: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000190FindResponse = {
  sokoCd: string;
  sokoNm: string;
  sokoNmr: string;
  sokoKana: string;
  sokoshubetsuKbn: string;
  logicalsokoCd: string;
  physicalsokoCd: string;
  locationkanriKbn: string;
  sakujoyoteiKbn: string;
};

export const B000190Find = (props: B000190FindRequest) => {
  return RestClient.get<PageableResponse<B000190FindResponse[]>>(
    "b000190/find",
    {
      params: props,
    }
  );
};

export type B000190GetRequest = {
  sokoCd: string;
} & Partial<{
  sokoshubetsuList: string[];
}>;

export type B000190GetResponse = {
  sokoCd: string;
  sokoNm: string;
  sokoNmr: string;
  sokoKana: string;
  sokoshubetsuKbn: string;
  logicalsokoCd: string;
  physicalsokoCd: string;
  locationkanriKbn: string;
  sakujoyoteiKbn: string;
};

export const B000190Get = (props: B000190GetRequest) => {
  return RestClient.get<B000190GetResponse>("b000190/get", {
    params: props,
  });
};

//倉庫名表示(コンポーネントはsokoNmr)
export const B000190SokoNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCd === "") {
    methods.setValue("sokoNmr", data.sokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNmr", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNmr", "");
    });
};

//倉庫名表示(コンポーネントはsokoNm)
export const B000190SokoNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCd === "") {
    methods.setValue("sokoNm", data.sokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNm", response.data.sokoNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNm", "");
    });
};

//倉庫名(Form)表示
export const B000190SokoNmrFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCdFrom === "") {
    methods.setValue("sokoNmrFrom", data.sokoCdFrom);
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCdFrom,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNmrFrom", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNmrFrom", "");
    });
};

//倉庫名(To)表示
export const B000190SokoNmrTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCdTo === "") {
    methods.setValue("sokoNmrTo", data.sokoCdTo);
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCdTo,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNmrTo", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNmrTo", "");
    });
};

//受注入力、セット構成品、受注ワーク入力、売上入力
export const B000190SokoNmSokoshubetsuKbn = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCd === "") {
    methods.setValue("sokoNm", data.sokoCd);
    methods.setValue("sokoshubetsuKbn", data.sokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNm", response.data.sokoNm ?? "");
      methods.setValue("sokoshubetsuKbn", response.data.sokoshubetsuKbn ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNm", "");
      methods.setValue("sokoshubetsuKbn", "");
    });
};

//倉庫移動入力(本社業務)払出倉庫表示
export const B000190Haraidashisoko = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.haraidashisokoCd === "") {
    methods.setValue("haraidashisokoNmr", data.haraidashisokoCd);
    methods.setValue("haraidashisokoShubetsuKbn", data.haraidashisokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.haraidashisokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("haraidashisokoNmr", response.data.sokoNmr ?? "");
      methods.setValue(
        "haraidashisokoShubetsuKbn",
        response.data.sokoshubetsuKbn ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("haraidashisokoNmr", "");
      methods.setValue("haraidashisokoShubetsuKbn", "");
    });
};

//倉庫移動入力受入倉庫表示
export const B000190Ukeiresoko = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.ukeiresokoCd === "") {
    methods.setValue("ukeiresokoNmr", data.ukeiresokoCd);
    methods.setValue("ukeiresokoShubetsuKbn", data.ukeiresokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.ukeiresokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("ukeiresokoNmr", response.data.sokoNmr ?? "");
      methods.setValue(
        "ukeiresokoShubetsuKbn",
        response.data.sokoshubetsuKbn ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("ukeiresokoNmr", "");
      methods.setValue("ukeiresokoShubetsuKbn", "");
    });
};

//在庫調整入力倉庫名表示(コンポーネントはsokoNmr)倉庫種別区分とロケーション管理区分取得
export const B000190SokoNmrSokoshubetsuKbnLocationkanriKbn = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCd === "") {
    methods.setValue("sokoNmr", data.sokoCd);
    methods.setValue("sokoshubetsuKbn", data.sokoCd);
    methods.setValue("locationkanriKbn", data.sokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNmr", response.data.sokoNmr ?? "");
      methods.setValue("sokoshubetsuKbn", response.data.sokoshubetsuKbn ?? "");
      methods.setValue(
        "locationkanriKbn",
        response.data.locationkanriKbn ?? ""
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNmr", "");
      methods.setValue("sokoshubetsuKbn", "");
      methods.setValue("locationkanriKbn", "");
    });
};

// 発注入力,仕入入力でつかう
export const B000190SokoNmrSokoshubetsuKbn = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.sokoCd === "") {
    methods.setValue("sokoNm", "");
    methods.setValue("sokoshubetsuKbn", "");
    return;
  }
  await B000190Get({
    sokoCd: data.sokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNm", response.data.sokoNmr ?? "");
      methods.setValue("sokoshubetsuKbn", response.data.sokoshubetsuKbn ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNm", "");
      methods.setValue("sokoshubetsuKbn", "");
    });
};

//委託倉庫名表示(コンポーネントはsokoNmr)
export const B000190ItakusokoNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.itakusokoCd === "") {
    methods.setValue("sokoNmr", data.itakusokoCd);
    return;
  }
  await B000190Get({
    sokoCd: data.itakusokoCd,
    sokoshubetsuList: data.sokoshubetsuList,
  })
    .then((response) => {
      methods.setValue("sokoNmr", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("sokoNmr", "");
    });
};

// 論理倉庫名表示(コンポーネントはlogicalsokoNmr)
export const B000190LogicalsokoNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.logicalsokoCd === "") {
    methods.setValue("logicalsokoNmr", "");
    return;
  }
  await B000190Get({
    sokoCd: data.logicalsokoCd,
  })
    .then((response) => {
      methods.setValue("logicalsokoNmr", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("logicalsokoNmr", "");
    });
};

// 物理倉庫名表示(コンポーネントはphysicalsokoNmr)
export const B000190PhysicalsokoNmr = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.physicalsokoCd === "") {
    methods.setValue("physicalsokoNmr", "");
    return;
  }
  await B000190Get({
    sokoCd: data.physicalsokoCd,
  })
    .then((response) => {
      methods.setValue("physicalsokoNmr", response.data.sokoNmr ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("physicalsokoNmr", "");
    });
};
